import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ProfileService {
  constructor(private http: HttpClient) {}

  getUserProfile():Observable<any>{
    return this.http.get(environment.Server_URL+'/user');
  }

  getuserinfo(id:any):Observable<any>{
    return this.http.get(environment.Server_URL+'/show/user/'+id);
  }
}
